import { CanActivateFn, Router } from '@angular/router';
import { CommunityService, TravelService } from '../../api/services';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { map, switchMap } from 'rxjs';
import { CommunityItem } from '../../api/models';

export const communityGuard: CanActivateFn = (route, state) => {
  const communityService = inject(CommunityService);
  const travelService = inject(TravelService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Utente non loggato
  const myId = authService.user.value?.id;
  if (!myId) {
    // se non sono loggato prima mi porta al login poi all url della pagina da cui provenivo
    return router.createUrlTree(['/login'], {
      queryParams: { back_to_url: state.url },
    });
  }

  // ID del viaggio dalla route
  const travelId = Number(route.params['id']);

  return travelService.travelControllerGetTravel({ id: travelId }).pipe(
    switchMap((res) => {
      const travel = res.data;

      // Se il viaggio non ha visibility 4 ok
      if (travel.visibility?.id !== 4) {
        return [true];
      }

      // Community richieste dal viaggio
      const travelCommunities = travel.visibility_metadata as CommunityItem[];

      if (!travelCommunities || travelCommunities.length === 0) {
        return [true];
      }

      // Carico le community dell’utente
      return communityService.communityControllerGetJoined().pipe(
        map((myRes) => {
          const myCommunities = myRes.data.list as CommunityItem[];
          // Controllo appartenenza
          const belongs = travelCommunities.some((tc) =>
            myCommunities.some((mc) => mc.id === tc.id),
          );

          if (!belongs) {
            // Redirect alla pagina del viaggio
            return router.createUrlTree([
              '/viaggi-di-gruppo',
              travel.countries[0].country.ISO,
              travel.countries[0].country.name,
              travel.id,
              travel.name,
            ]);
          }

          return true;
        }),
      );
    }),
  );
};
